import { FormMutationInterface } from "@kernel/form/interfaces/form-mutation.interface";

export const createStockTypeConfig: () => FormMutationInterface = () => ({
  name: "createStockType",
  paramName: "stockType",
  paramType: "StockTypeInput",
  select: ["id"],
});
